import { useState, FC } from 'react';
import { Button, Tabs, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { Trans } from 'react-i18next';
import Cookies from 'js-cookie';

import { HeaderButton } from 'componets/ui';
import { LoginLayout } from 'componets/layouts';
import { CreateAccountForm } from './CreateAccountForm';
import { CreateAccountNotifyNewsletter } from './CreateAccountNotifyNewsletters';

import { useTranslate } from 'hooks';

import { register } from 'features/registration/actions';

import { TARGET_URL } from 'utils/constants';
import Utils from 'utils/utils';
import { getInStorage, removeFromStorage } from 'utils';

import { FieldData } from 'models';

import { AppDispatch } from 'store';

import styles from '../../index.module.scss';

export const CreateAccount: FC = () => {
	const { alreadyHaveAccountText, privateText, companyText, signUpText, loginText } = useTranslate([
		'alreadyHaveAccountText',
		'privateText',
		'companyText',
		'signUpText',
		'loginText',
	]);

	const [fields, setFields] = useState<FieldData[]>([]);

	const [type, setType] = useState('user');
	const [isNotifyNewslettersOpen, setIsNotifyNewslettersOpen] = useState(false);
	const [notifyNewsletters, setNotifyNewsletters] = useState('1');

	const dispatch = useDispatch<AppDispatch>();

	const onFinish = async (data: any) => {
		const values = {
			...data,
			userType: type,
			notifyNewsletters,
			affiliateInfo: Cookies.get(TARGET_URL),
		};

		return dispatch(register(values))
			.unwrap()
			.then(() => {
				removeFromStorage('referralEmail');
			})
			.catch(({ errors }) => {
				Utils.injectFormErrors(fields, errors, setFields);
			});
	};

	const formProps = {
		onFinish,
		fields,
		onFieldsChange: setFields,
		initialValues: {
			email:
				Utils.safeParseJson(getInStorage('referralEmail') || '') || sessionStorage.getItem('email'),
		},
	};

	return (
		<LoginLayout top={<HeaderButton text={alreadyHaveAccountText} link="/" title={loginText} />}>
			<Typography.Title level={4}>{signUpText}</Typography.Title>

			<Typography.Text type="secondary">
				<Trans i18nKey="signUpBonusText" components={{ b: <Typography.Text /> }} />
			</Typography.Text>

			<Tabs
				type="card"
				className={styles.forms}
				defaultActiveKey={type}
				onChange={(v) => setType(v)}
				destroyInactiveTabPane
				items={[
					{ key: 'user', label: privateText, children: <CreateAccountForm {...formProps} /> },
					{ key: 'company', label: companyText, children: <CreateAccountForm {...formProps} /> },
				]}
			/>

			<Typography.Text type="secondary" className={styles.news}>
				{notifyNewsletters !== '0' && (
					<Trans
						i18nKey="receiveInfoText"
						components={{
							button: <Button type="text" onClick={() => setIsNotifyNewslettersOpen(true)} />,
						}}
					/>
				)}
			</Typography.Text>

			{isNotifyNewslettersOpen && (
				<CreateAccountNotifyNewsletter
					isOpen={isNotifyNewslettersOpen}
					onClose={() => setIsNotifyNewslettersOpen(false)}
					onCancel={() => {
						setNotifyNewsletters('0');
						setIsNotifyNewslettersOpen(false);
					}}
				/>
			)}
		</LoginLayout>
	);
};
